import React, { PureComponent } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

export default class DLMenu extends PureComponent {
    static Item( props ) {
        return ( <Dropdown.Item { ...props } /> );
    }
    static Divider( props ) {
        return ( <Dropdown.Divider { ...props } /> );
    }
    render() {
        const inlineStyle = { ...this.props.style };
        const icon = this.props.icon || ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' /> );

        var dropdownProps = { ...this.props, icon };
        delete dropdownProps.children;
        delete dropdownProps.fullWidth;
        delete dropdownProps.className;

        return (
            <div className={ `semantic-wrapper ${ style.semanticMenu } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            style={ inlineStyle }>
                <Dropdown className={ `${ style.semanticDropdown }` }
                { ...dropdownProps }>
                    <Dropdown.Menu>
                        { this.props.children }
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

DLMenu.defaultProps = {
    className: '',
    style: {},
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
};
